import React, { useEffect, useState } from 'react'

// icons
import FeatherIcon from 'feather-icons-react';

// includes
import AddSignature from './includes/AddSignature';

export default function DomainListing(props) {
    // props
    const {
        sectionLoading,

        setDNSsettingsVisibility,
        notificationsData,

        handleDeleteDomain
    } = props

    // states
    // const [addSignVisibility, setAddSignVisibility] = useState(false)
    const [domainDetails, setDomainDetails] = useState(null)

    useEffect(() => {
        if (notificationsData?.postmark_domain_detail) {
            const data = JSON.parse(notificationsData?.postmark_domain_detail)

            setDomainDetails(data) // setting domain details
        }
    }, [notificationsData])

    return (
        <div className={`page-border-box2 mb-3 mb-md-4 customer-order-notifications ${sectionLoading ? "disabled" : ""}`}>
            <div className="pbb2-inner">
                {/* item */}
                <div className="ds-item">
                    {/* top sec */}
                    <div className="dsi-top-sec d-flex pb-1">
                        {/* name */}
                        <div className="domain-name">
                            <p className="st-fw-700 mt-1">
                                <FeatherIcon
                                    icon={(domainDetails?.dkimverified && domainDetails?.returnpathdomainverified) ? "check" : "x-circle"}
                                    size="15"
                                    className={(domainDetails?.dkimverified && domainDetails?.returnpathdomainverified) ? "" : "text-danger"}
                                />
                                <span className="ms-1">
                                    {notificationsData?.postmark_domain}
                                </span>
                            </p>
                        </div>

                        {/* other info */}
                        <div className="other-info ms-auto d-flex flex-wrap">
                            {/* text */}
                            {
                                domainDetails?.dkimverified ? (
                                    <p className="info-text d-flex align-items-center st-text-success st-fw-600 me-3">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon"
                                        />
                                        <span className="ms-1">DKIM verified</span>
                                    </p>
                                ) : (
                                    <p className="info-text d-flex align-items-center st-text-danger st-fw-600 me-3">
                                        <FeatherIcon
                                            icon="x-circle"
                                            size="15"
                                            className="icon"
                                        />
                                        <span className="ms-1">DKIM not verified</span>
                                    </p>
                                )
                            }

                            {/* text */}
                            {
                                domainDetails?.returnpathdomainverified ? (
                                    <p className="info-text d-flex align-items-center st-text-success st-fw-600 me-3">
                                        <FeatherIcon
                                            icon="check"
                                            size="15"
                                            className="icon"
                                        />
                                        <span className="ms-1">Return-Path verified</span>
                                    </p>
                                ) : (
                                    <p className="info-text d-flex align-items-center st-text-danger st-fw-600 me-3">
                                        <FeatherIcon
                                            icon="x-circle"
                                            size="15"
                                            className="icon"
                                        />
                                        <span className="ms-1">Return-Path not verified</span>
                                    </p>
                                )
                            }

                            {/* link */}
                            <p className="info-link d-flex align-items-center st-text-primary st-fw-600 cursor-pointer hover-underline-link me-3" onClick={ev => {
                                ev.preventDefault()

                                setDNSsettingsVisibility(true)
                            }}>
                                DNS Settings
                            </p>

                            {/* btn */}
                            <p
                                className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center cursor-pointer"
                                title="remove"
                                onClick={handleDeleteDomain}>
                                <FeatherIcon
                                    icon="trash"
                                    size="15"
                                    className="icon"
                                />
                            </p>
                        </div>
                    </div>

                    {
                        /* main info sec */
                        (domainDetails?.dkimverified && domainDetails?.returnpathdomainverified) ? null : ( // only show when varification is successful
                            <div className="main-info-sec pt-3 text-center">
                                <FeatherIcon
                                    icon="alert-triangle"
                                    size="30"
                                    className="icon"
                                />
                                <p className="mt-2">
                                    {/* <span className="text-decoration-underline st-fw-600 cursor-pointer">Add a DKIM DNS record</span> to send from any email address on this domain, or add and confirm a sender signature below */}
                                    Add a <span className="st-fw-600 cursor-pointer">DKIM DNS record</span> to send from any email address on this domain, or add and confirm a sender signature below
                                </p>
                            </div>
                        )
                    }

                    {/* bottom sec */}
                    <div className="bottom-sec d-flex flex-wrap align-items-center mt-2">
                        {/* <button className="st-btn st-btn-primary st-btn-sm"
                            onClick={ev => {
                                ev.preventDefault()

                                setAddSignVisibility(!addSignVisibility)
                            }}>
                            {
                                addSignVisibility ? (
                                    "Remove Signatures"
                                ) : (
                                    "Add Signatures"
                                )
                            }
                        </button> */}
                        {/* <span className="mx-2 st-text-color2">or</span>
                        <p>
                            <span className="text-decoration-underline st-text-primary st-fw-600 cursor-pointer">Add a DKIM DNS record</span> to send from any email address on this domain.</p> */}

                        {/* {
                            addSignVisibility ? (  // if sign view is visible
                                <AddSignature
                                    notificationsData={notificationsData}
                                />
                            ) : null
                        } */}
                    </div>
                </div>
            </div>
        </div>
    )
}
